module.exports = "/images/icon_cart.png?9ddea1f597756211c56e56d83660708c";